import { useAuth } from '../../hooks/useAuth';
import { useTier } from '../../context/TierContext';
import styles from './TestTierToggle.module.css';

const TIERS = [
  { id: 'access', label: 'Access' },
  { id: 'one', label: 'ONE' },
  { id: 'plus', label: 'PLUS' }
];

// Pinned at the top of the Test Admin Dashboard.
//
// Gated on `sandboxMode`, which AuthContext takes from /auth/me — so it is the SERVER that
// decides whether this renders, not the client. For a real member or a logged-out visitor the
// markup is never produced at all: this is absence, not `display: none`. The tier it selects is
// a PREVIEW; it never writes a stored tier, and the prices that come back are the server's.
const TestTierToggle = () => {
  const { sandboxMode } = useAuth();
  const { tierType, setTier } = useTier();

  if (!sandboxMode) return null;

  return (
    <div className={styles.tierToggle} data-testid="test-tier-toggle">
      <span className={styles.tierToggleLabel}>Preview as:</span>
      <div className={styles.tierToggleButtons} role="group" aria-label="Preview membership tier">
        {TIERS.map((tier) => (
          <button
            key={tier.id}
            type="button"
            data-tier={tier.id}
            aria-label={`Preview as ${tier.label} membership`}
            aria-pressed={tierType === tier.id}
            className={`${styles.tierToggleBtn} ${tierType === tier.id ? styles.tierToggleBtnActive : ''}`}
            onClick={() => setTier(tier.id)}
          >
            {tier.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TestTierToggle;
